import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Header from "./common/header";
import LeadListing from "./Listing/leadlisting";
import Login from "./login";
// import NewLeadForm from './booking/newLeadForm.js'
import Cookies from "universal-cookie";
import UploadCSV from "./common/UploadCSV";

/* //* Axios configuration */
import "./common/axiosConfig"; // Import axios configuration to set up interceptors

const cookies = new Cookies();

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loggedIn: false,
    };
  }

  componentDidMount() {
    let auth_token = cookies.get("auth_token");
    if (!auth_token && window.location.pathname !== "/login") {
      window.location.href = "/login";
    }
    if (auth_token) {
      this.setState({ loggedIn: true });
    }
  }

  render() {
    return (
      <>
        {/* <head>
        <link rel="stylesheet" href="https://react-datatable.in/static/css/main.341eb631.css" crossorigin="anonymous"></link>        
      </head> */}
        <style>
          {`td.address, th.address {
              background-color: #188fbd;
              color: #fff;
            }
            thead.custom-header-style {
                background-color: #ddd;
                color: #fff;
            }
            thead.custom-header-style th.sortable {
                color: #000;
            }`}
        </style>
        {this.state.loggedIn && <Header />}
        <div className={this.state.loggedIn ? "container" : "container-fluid"}>
          <div className="row">
            <Router>
              <Switch>
                <Route exact path="/">
                  {this.state.loggedIn ? (
                    <div className="col px-0">
                      <LeadListing />
                    </div>
                  ) : (
                    <div
                      className="d-flex justify-content-center w-100"
                      style={{ marginTop: "20em" }}
                    >
                      <div class="loader"></div>
                      <style>{`
                .loader {
                  border: 10px solid #f3f3f3;
                  border-radius: 50%;
                  border-top: 10px solid #f05c4d;
                  width: 120px;
                  height: 120px;
                  -webkit-animation: spin 2s linear infinite; /* Safari */
                  animation: spin 2s linear infinite;
                }
                
                /* Safari */
                @-webkit-keyframes spin {
                  0% { -webkit-transform: rotate(0deg); }
                  100% { -webkit-transform: rotate(360deg); }
                }
                
                @keyframes spin {
                  0% { transform: rotate(0deg); }
                  100% { transform: rotate(360deg); }
                }
                `}</style>
                    </div>
                  )}
                </Route>
                <Route exact path="/login">
                  <div
                    className="col px-0"
                    style={{ position: "relative", height: "100vh" }}
                  >
                    <Login />
                  </div>
                </Route>
                <Route exact path="/upload">
                  <div className="col px-0" style={{ position: "relative" }}>
                    <UploadCSV />
                  </div>
                </Route>
              </Switch>
            </Router>
          </div>
        </div>
      </>
    );
  }
}

export default App;
